<template>
  <div class="forestCommentPage" id="forestComment">
    <van-list
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      :offset="100"
      :finished-text="$t('common.noneMore')"
      v-if="!commentMainShow"
    >
      <div class="list-item">
        <van-cell v-for="item in commentlists" :key="item.id" class="item">
          <div class="critic">
            <dl class="criticInfo">
              <dt class="criticImg">
                <img
                  :src="item.avatar ? item.avatar : baseUrl + 'userDefault.png'"
                  alt
                />
              </dt>
              <dd class="criticName">{{ item.nickname }}</dd>
              <dd class="criticTime">{{ item.createTime }}</dd>
              <dd class="criticAddress">{{ item.address }}</dd>
            </dl>
            <div class="commentMain">
              <p v-html="item.comment"></p>
              <van-grid :column-num="3" class="commentImgs clearfix">
                <van-grid-item
                  class="imgList lf"
                  v-for="(imgItem, index) in item.baseFiles"
                  :key="index"
                  @click="Showswiper(item.baseFiles, index)"
                >
                  <van-image
                    fit="contain"
                    v-if="imgItem.url"
                    :src="`${imgItem.url}`"
                  />
                </van-grid-item>
              </van-grid>
            </div>
          </div>
        </van-cell>
      </div>
    </van-list>
    <div class="nonePage" v-if="commentMainShow">
      <img :src="nonePng" alt />
      <p>{{ $t("common.noDataTip") }}</p>
    </div>

    <div class="addCommentBox">
      <img
        :src="baseUrl + 'addCommontIcon.png'"
        alt
        srcset
        @click="addForestCommont"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
import nonePng from "@/assets/none.png";
export default {
  name: "forestComment",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      nonePng: nonePng, //默认图片

      forestObjid: "",
      commentMainShow: false,
      commentlists: [],
      backstagelists: [],
      imgList: [],
      showImgs: [], // 展示的img
      swiperShow: false,
      swipercliclIndex: 0,
      imgShowStyle: "",
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
    };
  },
  props: {
    point: {
      type: String,
    },
    paramData: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.forestObjid = this.$route.query.commonId;
      if (this.forestObjid == undefined) {
        this.forestObjid = this.paramData.id;
      }
      this.imgShowStyle = this.paramData.showMap;
      // this.getTest()
    });
  },
  methods: {
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.universal.forest
        .getAreaCommentList({
          pageNum: _this.page,
          pageSize: _this.pageSize,
          interiorPoint: _this.point,
        })
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.backstagelists = res.data.list;
            _this.commentCount = total;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              this.$store.commit("setCallBackCommont", "");
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.commentlists = this.commentlists.concat(this.backstagelists);
      if (this.commentlists.length < 1) {
        this.commentMainShow = true;
      }
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },

    Showswiper(dataImgs, showIndex) {
      let magnifyList = [];
      dataImgs.forEach(SelectBigImgs);
      function SelectBigImgs(item, index) {
        magnifyList.push(item.url);
      }
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true,
      };
      // this.$emit("showBigImg", data);
      this.$store.commit("setDataImgs", data);
    },
    //添加林地评论
    addForestCommont() {
      let data = {
        pageType: "forest",
        type: true,
        id: this.forestObjid,
      };

      this.$store.commit("setAddCommontType", data);
    },
  },
  computed: {
    ...mapState(["callBackCommontType"]),
  },
  watch: {
    point: function (value) {
      this.page = 0;
      this.commentCount = 0;
      this.point = value;
      this.getTest();
    },

    paramData: {
      handler: function () {
        console.log(this.paramData);
        let _this = this;
        this.forestObjid = this.paramData.id;
        _this.imgShowStyle = this.paramData.showMap;
      },
      deep: true,
    },
    callBackCommontType: function (value) {
      if (value == "forest") {
        this.commentlists = [];
        this.backstagelists = [];
        this.page = 0;
        this.commentCount = 0;
        this.finished = false;
        this.loading = false; //是否处于加载状态
        this.isLoading = false; //是否处于下拉刷新状态
        this.commentMainShow = false;
        this.getTest();
      }
    },
  },
  //关闭页面时销毁监听事件
  beforeDestroy() {
    this.$store.commit("setCallBackCommont", ""); //将store的值清空
  },
};
</script>

<style lang="less">
/*eslint-disable*/
.forestCommentPage {
  width: 100%;
  height: 100%;
  font-family: "PingFangSC-Regular";
  color: #000;
  overflow-y: scroll;
  position: relative;
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  // .tit {
  //   font-size: 14px;
  //   font-family: "PingFangSC-Medium";
  //   font-weight: 500;

  //   .commentCount {
  //     font-size: 8px;
  //     opacity: 0.5;
  //   }
  // }

  .item {
    margin-top: 17px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(235, 235, 235, 1);

    .critic {
      position: relative;

      dl.criticInfo {
        position: relative;

        dt {
          position: absolute;
          top: 0;
          left: 0;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          -webkit-border-redius: 50%;
          -moz-border-redius: 50%;

          background: #d8d8d8;

          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            -webkit-border-redius: 50%;
            -moz-border-redius: 50%;
          }
        }

        dd {
          color: #999;
        }

        .criticName {
          margin-left: 45px;
          width: 100px;
          font-size: 12px;
          color: #333;
          min-height: 12px;
          line-height: 14px;
        }

        .criticTime {
          display: inline-block;
          margin-top: 6px;
          margin-left: 45px;
          font-size: 10px;
          line-height: 14px;
        }

        .criticAddress {
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      .commentMain {
        margin-top: 10px;

        p {
          text-indent: 2em;
          color: #999;
          font-size: 12px;
          line-height: 16px;
        }
      }

      .commentImgs {
        margin: 8px 0;
        .imgList {
          .van-grid-item__content {
            padding: 8px 10px;
          }

          .van-grid-item__content::after {
            border: 0 none;
          }
        }
      }

      .criticLike {
        position: absolute;
        top: 0;
        right: 10px;

        span {
          display: block;
        }

        .criticLikeIcon {
          font-size: 15px;
          color: #000;
        }

        .criticCount {
          font-size: 10px;
          color: #000;
        }

        .red {
          color: #4bc08a;
        }
      }
    }
  }
  .addCommentBox {
    width: 40px;
    height: 40px;
    position: fixed;
    bottom: 60px;
    right: 5px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    z-index: 999;
    background-color: #33bc6c;
    img {
      max-width: 100%;
    }
  }
}
</style>